import React from 'react';
import VehicleDetail from './components/VehicleDetail';

const VehicleDetailPage: React.FC = () => {
  // Title is set at the application level
  return <VehicleDetail />;
};

export default VehicleDetailPage;